export default __webpack_public_path__ + "static/media/1030.f70aa379.png";